import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import "../../../App.css";
import Divider from "@material-ui/core/Divider";
import * as ROUTES from "../../../constants/routes";
import { Link } from "react-router-dom";

import { styles } from "../../../breakpoints";
import { Helmet } from "react-helmet";

class Bewerbungen extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div style={{ marginTop: 112 }}>
        <Helmet>
          <title>Bewerbungen</title>
          <meta name="description" content="Unser Impressum" />
        </Helmet>

        <div style={{ textAlign: "center", padding: "16px", marginBottom: 24 }}>
          <div>
            <div style={{ marginTop: "2vh" }}>
              <div style={{ width: "100%" }}>
                <p className={classes.headlines}>Bewerbungen</p>
                <br />
                <p className={classes.flowText} style={{ textAlign: "start" }}>
                  Wir freuen uns über Initiativbewerbungen und Bewerbungen zur
                  Ausbildung zur Zahnmedizinische/r Fachangestellte/r (m,w,d).
                </p>
                <br />
                <p className={classes.flowText} style={{ textAlign: "start" }}>
                  Schicken Sie gerne Ihre Unterlagen per Post an:
                  <br />
                  <br />
                  Zahnarztpraxis Link
                  <br />
                  Ullastr. 3<br />
                  63829 Krombach
                  <br />
                </p>
                <br />
                <p className={classes.flowText} style={{ textAlign: "start" }}>
                  Oder per Email an: <br />
                  <a
                    href="mailto:bewerbung@zahnarztpraxis-link.de"
                    style={{
                      color: "#13294b",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    bewerbung@zahnarztpraxis-link.de{" "}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Bewerbungen);
<br />;
